"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const RenderComponents_1 = require("../types/RenderComponents");
const cameraRenderGetOnQrCallback = ({ onQRCodeRead, onBarCodeRead, }) => {
    if (!onQRCodeRead && !onBarCodeRead) {
        return undefined;
    }
    return (event) => {
        if (event.type === RenderComponents_1.CODE_TYPES.QR) {
            if (onQRCodeRead) {
                onQRCodeRead(event);
            }
        }
        else if (onBarCodeRead) {
            onBarCodeRead(event);
        }
    };
};
exports.default = cameraRenderGetOnQrCallback;
